/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Modal_Description2Inputs */

const en_coinvestments_closedeal_modal_description2 = /** @type {(inputs: Coinvestments_Closedeal_Modal_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is a one-way action. Once closed, reopening requires Vega support.`)
};

/**
* | output |
* | --- |
* | "This is a one-way action. Once closed, reopening requires Vega support." |
*
* @param {Coinvestments_Closedeal_Modal_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_modal_description2 = /** @type {((inputs?: Coinvestments_Closedeal_Modal_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Modal_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_modal_description2(inputs)
});
export { coinvestments_closedeal_modal_description2 as "coInvestments_closeDeal_modal_description" }